import { Box, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useIsMobile, useL10n } from '@uplift/hooks';
import { UpliftThemeProvider, AddressVerificationContext, addressVerificationReducer, EditableSectionsContext } from '@uplift/ui-v2';
import React, { useMemo, useReducer, useState } from 'react';
import { MainLayout } from '../../components';
import { ProfileSettings } from './profile';
import { settingsRoute } from '@uplift/constants';


export const SettingsPage: React.VFC = () => {
  const { classes } = useStyles();
  const l10n = useL10n();
  const isMobile = useIsMobile('sm');
  const edit: string = settingsRoute.useQueryParam('edit');
  const [ editKey, setEditKey ] = useState(edit || null);

  const [ addressState, addressDispatch ] = useReducer(addressVerificationReducer, { shouldReverifyAddress: false, parsedVerifiedAddress: null });
  const addressCtx = useMemo(() => ({ state: addressState, dispatch: addressDispatch }), [ addressState, addressDispatch ]);

  return (
    <MainLayout>
      <UpliftThemeProvider>
        <AddressVerificationContext.Provider value={addressCtx}>
          <EditableSectionsContext.Provider value={{ editKey, setEditKey }}>
            <Box color="darkSlate" mb={isMobile ? 3 : 7}>
              <Typography variant={isMobile ? 'h1' : 'h3'}>{l10n.pages.accountSettings}</Typography>
            </Box>
            <Box className={classes.container} bgcolor="white">
              <Box className={classes.contentContainer}>
                <ProfileSettings />
              </Box>
            </Box>
          </EditableSectionsContext.Provider>
        </AddressVerificationContext.Provider>
      </UpliftThemeProvider>
    </MainLayout>
  );
};


const useStyles = makeStyles()((theme) => ({
  container: {
    maxWidth: theme.spacing(96), // 768px
    [theme.breakpoints.down('sm')]: {
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      marginRight: theme.spacing(-2),
      marginLeft: theme.spacing(-2)
    },
  },
  contentContainer: {
    paddingBottom: theme.spacing(16),
    [theme.breakpoints.down('sm')]: {
      paddingTop: theme.spacing(3),
      background: theme.palette.grey[50],
      flex: 1,
      paddingBottom: theme.spacing(17.5),
      marginBottom: theme.spacing(-2)
    }
  },
  tabs: {
    boxShadow: `inset 0 -1px 0 ${theme.palette.divider}`,
    '& button[role="tab"]': {
      fontWeight: 700,
      [theme.breakpoints.down('sm')]: {
        flex: 1
      }
    },
    zIndex: 2,
    background: theme.palette.common.white,
  }
}));
